import { configureStore } from "@reduxjs/toolkit";
import authReducer from "../features/auth2/authSlice";
import userReducer from "../features/user/userSlice";
import studentReducer from "../features/student/studentSlice";
import customizationReducer from "../../newTestPrepDesign/store/customizationReducer";
import wishlistReducer from "../../context/reducer/classes_reducer";
import addressReducer from  "../features/userAddress/addressSlice"
import testAddressRecducer from  "../features/userAddress/addressDataSlice"
import ExamIdReducer from "../features/examTestTypeId"
import PurchaseTestReducer from "../../context/reducer/purchase_test_reducer";
import ProceedWithTestDataReducer from "../features/testTypecheckout/ProceedWithTestDataReducer"
const store = configureStore({
  reducer: {
    auth: authReducer,
    user: userReducer,
    student: studentReducer,
    customization: customizationReducer,
    // 👇 add wishlist here
    wishlist: wishlistReducer,
    address: addressReducer,
    examId : ExamIdReducer,
    testAddressData: testAddressRecducer,
    
    //  purchase test cart
    purchasetestcart:PurchaseTestReducer,
    selectedTestDataList :ProceedWithTestDataReducer

  },
});

export default store;
